<script setup lang="ts">
import { Bars2Icon } from '@heroicons/vue/20/solid';

withDefaults(defineProps<{
	draggable?: boolean;
}>(), {
	draggable: false,
});
</script>

<template>
	<div
		class="bg-primary-400 rounded-[7px] px-6 pt-3.5 pb-2.5 w-full text-left box-border border-2 transition-all ease-in-out duration-200 border-transparent flex items-center justify-between"
		:class="{
			'cursor-pointer': draggable,
		}"
	>
		<span class="text-xl leading-none">
			<slot />
		</span>
		<Bars2Icon
			v-if="draggable"
			class="w-5 opacity-25"
		/>
	</div>
</template>
